import { Card, Row } from 'antd';
import React from 'react'
import Heading from '../../../component/common/Heading';
import CRUDComponent from '../../../component/common/CRUD-Component';
import CONSTANTS from '../../../util/constant/CONSTANTS';
import { useNavigate } from 'react-router-dom';

const BenchMark = () => {
    const navigate = useNavigate()
    return (
        <>
            <div>
                <Card className="my-5">
                    <Heading>BenchMarks</Heading>
                    <Row>
                        <CRUDComponent
                            GET={{
                                API: CONSTANTS.API.Benchmark.getAll,
                                DataModifier: (res, API, Setrefresh) => {
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `B${data?.id.toString().padStart(7, "0")}`,


                                            view: {
                                                id: data?.id,
                                                onClick: () => {
                                                    navigate(`/app/benchmark/activity/${data?.id}`)
                                                }
                                            },

                                        }
                                    });
                                },
                                column: CONSTANTS.TABLE.BENCHMARK,
                            }}
                            // isSearch
                            UPDATE={{
                                API: CONSTANTS.API.Benchmark.update,
                                message: "Edit Benchmark successfully",
                                modaltitle: "Edit Benchmark",
                                modalFields: CONSTANTS.FORM_FIELD.BENCHMARK_MODAL,
                                // payloadModifier: (res) => res,
                            }}
                            CREATE={{
                                API: CONSTANTS.API.Benchmark.add,
                                message: "Created Benchmark successfully",
                                modaltitle: "Add Benchmark",
                                modalFields: CONSTANTS.FORM_FIELD.BENCHMARK_MODAL,
                                // payloadModifier: (res) => res,
                            }}
                            DELETE={{
                                API: CONSTANTS.API.Benchmark.delete,
                                message: "Deleted Successfully",
                            }}
                        />
                    </Row>
                </Card>

            </div>


        </>
    )
}

export default BenchMark